import { useNavigate, useParams } from "react-router-dom";
import { Tabs } from "../../components/common/Tabs";
import { useFeatureTheme } from "../../context/FeatureThemeContext";
import { ThemeSettingsTab } from "./ThemeSettingsTab";
import { InspectionScheduleTab } from "./InspectionScheduleTab";
import { FeatureTogglesTab } from "./FeatureTogglesTab";
import { SubscriptionSettingsTab } from "./SubscriptionSettingsTab";
import { DevicesTab } from "./DevicesTab";
import { TravelModeTab } from "./TravelModeTab";
import { SecurityCenterTab } from "./SecurityCenterTab";
import { QrLabelsTab } from "./QrLabelsTab";
import { RegistrationTab } from "./RegistrationTab";
import { YourDataTab } from "./YourDataTab";

/**
 * Route is "/settings/*" -- the wildcard segment (e.g. "security" from
 * /settings/security, as linked from TopBar's user menu) selects which tab
 * opens by default. Previously ignored entirely, so every deep link landed
 * on "Theme" regardless of which tab it pointed at.
 */
export function SettingsPage() {
  const { theme } = useFeatureTheme();
  const navigate = useNavigate();
  const params = useParams();
  const requestedTab = params["*"];

  const tabs = [
    { key: "theme", label: "Theme", content: <ThemeSettingsTab /> },
    // Ungated: this drives the due-hive flags every tier already sees.
    { key: "schedule", label: "Inspection Schedule", content: <InspectionScheduleTab /> },
    ...(theme === "Custom" ? [{ key: "features", label: "Feature Toggles", content: <FeatureTogglesTab /> }] : []),
    { key: "subscription", label: "Subscription", content: <SubscriptionSettingsTab /> },
    { key: "devices", label: "Trusted Devices", content: <DevicesTab /> },
    { key: "travel", label: "Travel Mode", content: <TravelModeTab /> },
    // Key must stay "qr" -- QR_SETTINGS_PATH in services/qrPreferences.js
    // deep-links here from the print warning itself.
    { key: "qr", label: "QR Labels", content: <QrLabelsTab /> },
    // Ungated: registration is a legal obligation in several states, and
    // charging for compliance is not a thing to do (#274).
    { key: "registration", label: "Registration", content: <RegistrationTab /> },
    { key: "security", label: "Security Center", content: <SecurityCenterTab /> },
    // Ungated, and for the same reason as Registration above: right of
    // access and right of erasure are obligations, not features. Putting
    // either behind a paid tier would mean charging somebody to exercise
    // a legal right.
    { key: "data", label: "Your Data", content: <YourDataTab /> },
  ];

  const defaultKey = tabs.some((t) => t.key === requestedTab) ? requestedTab : undefined;

  return (
    <div>
      <h1>Settings</h1>
      <Tabs tabs={tabs} defaultKey={defaultKey} onChange={(key) => navigate(`/settings/${key}`, { replace: true })} />
    </div>
  );
}
